import React from 'react';
import { useDarkMode } from 'utils/darkMode';
import './Select.css';

/**
 * Select - Base select/dropdown component
 * 
 * @param {Object} props
 * @param {Array} props.options - Array of {value, label} objects
 * @param {string} props.value - Selected value
 * @param {Function} props.onChange - Change handler
 * @param {string} props.placeholder - Placeholder text
 * @param {boolean} props.disabled - Disabled state
 * @param {boolean} props.error - Error state
 * @param {string} props.className - Additional CSS classes
 * @param {string} props.size - Select size: 'small', 'medium', 'large'
 */
const Select = ({
  options = [],
  value,
  onChange,
  placeholder,
  disabled = false,
  error = false,
  className = '',
  size = 'medium'
}) => {
  const { isDarkMode } = useDarkMode();
  // Check if this is for left panel - must check BEFORE building className
  const isLeftPanel = className.includes('left-panel');
  
  // Build className without theme if left panel
  const themeClass = isLeftPanel ? '' : (isDarkMode ? 'dark-theme' : 'light-theme');
  const wrapperClasses = `select-wrapper ${themeClass} ${error ? 'error' : ''} ${disabled ? 'disabled' : ''} ${className}`.trim().replace(/\s+/g, ' ');

  return (
    <div className={wrapperClasses}>
      <select
        value={value ?? ''}
        onChange={(e) => onChange && onChange(e.target.value)}
        disabled={disabled}
        className={`select select-${size}`}
      >
        {placeholder && !value && (
          <option value="" disabled hidden>
            {placeholder}
          </option>
        )}
        {options.map((option) => (
          <option key={option.value} value={option.value} disabled={option.disabled}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default Select;

